import SectionTitle from "./SectionTitle.js";
import Splider from "./Splider.js";

const Gallery = () => {
  return (
    <section className="section" id="gallery">
      <SectionTitle sectionTitle="Gallery"></SectionTitle>
      <Splider />
    </section>
  );
};

export default Gallery;
